export const SortTypes = {
	Asc: 'ASC',
	Desc: 'DESC',
};
